export default function PHP_sizeof() {
  return (
    <div>
      <h1>PHP_sizeof</h1>
    </div>
  );
}
